




































































































































































































































































































































































import { Component } from "vue-property-decorator";
import axios from "axios";
import HacoBase from "../HacoBase";
interface DetailData {
  id: number;
  itemCoaterSizeName: string;
  width: number;
  dimension: number;
  unprintableWidth: number;
  unprintableDimension: number;
  coaterCosts: object[];
  coaterFixedCosts: object[];
}
@Component
export default class CoaterEditComp extends HacoBase {
  editData: any = {};
  $debugServer!: string;
  costTypeA = true;
  costTypeB = false;
  selectedPaper = "";
  selectedMachinePaper = "";
  defData: any = {
    itemCoaterName: "",
    costType: "manual",
    manualCoatingFixedCosts: [],
    manualCoatingCosts: {},
    machineCoatingMinimumCosts: {},
    machineCoatingCostPerSheets: {}
  };
  paperSizeShows = false;
  paperSizeList: string[] = [];
  machinePaperSizeList: string[] = [];
  selected = "";
  errantSheet: string[] = [];
  errantCost: string[] = [];

  stopProgression(): void {
    void 0;
  }

  /** 変数名長いので短縮 */
  get oneLine(): [] {
    return this.editData.coater.machineCoatingCostPerSheets[
      this.selectedMachinePaper
    ];
  }

  /** 選択したタブを消す */
  deleteCost(key: string, isManual: boolean): void {
    const confirmation: boolean = confirm(
      this.$t("message.editCommon.deleteConfirmation") as string
    );
    if (confirmation === false) {
      return;
    }
    let costList: any;
    let focusedKey = "";
    if (isManual === true) {
      costList = this.editData.coater.manualCoatingCosts;
    } else {
      costList = this.editData.coater.machineCoatingCostPerSheets;
    }

    Object.keys(costList).forEach((k: string): void => {
      if (k === key) {
        delete costList[k];
      } else {
        focusedKey = k;
      }
    });
    if (isManual === true) {
      this.selectedPaper = focusedKey;
    } else {
      this.selectedMachinePaper = focusedKey;
    }
  }

  /** 新しいPaperサイズ追加 */
  addPaperSize(): void {
    if (this.selected === "") {
      return;
    }
    const newVal: string =
      this.editData.coater.costType === "machine"
        ? this.machinePaperSizeList[parseInt(this.selected, 10)]
        : this.paperSizeList[parseInt(this.selected, 10)];

    const newCoatingCosts: object[] = [];
    Object.keys(this.editData.coatingTypes).forEach((k: string): void => {
      newCoatingCosts.push({
        itemPaperSizeId: parseInt(newVal, 10),
        coatingTypeId: parseInt(k, 10),
        cost: 0
      });
    });

    if (this.editData.coater.costType === "machine") {
      const costSheet: any = this.editData.coater.machineCoatingCostPerSheets;
      costSheet[newVal] = [newCoatingCosts];
      this.selectedMachinePaper = newVal;

      const minCosts: any = this.editData.coater.machineCoatingMinimumCosts;
      minCosts[newVal] = [];
      Object.keys(this.editData.coatingTypes).forEach((k: string): void => {
        minCosts[newVal].push({
          itemPaperSizeId: parseInt(newVal, 10),
          coatingTypeId: parseInt(k, 10),
          cost: 0
        });
      });
      this.resetSheetFromEle();
      this.setSheetFrom();
      this.checkSheetValue(this.editData.coater.machineCoatingCostPerSheets);
      this.checkMachineCosts();
      /** 選択した用紙は次回の選択対象から外す */
      this.machinePaperSizeList.splice(parseInt(this.selected, 10), 1);
    } else {
      /** 選択した用紙は次回の選択対象から外す */
      this.paperSizeList.splice(parseInt(this.selected, 10), 1);

      this.editData.coater.manualCoatingCosts[newVal] = newCoatingCosts;
      this.selectedPaper = newVal;
      this.checkManualCosts();
    }
    this.showPaperSizeSelector(false);
  }

  mounted(): void {
    let editId: number;
    if (this.$route.params.id === undefined) {
      return;
    } else {
      editId = parseInt(this.$route.params.id, 10);
      this.defData.id = editId;
      let url = this.$debugServer + "/api/v1_inner/coater/";
      const accessMethod = "get";
      /** 新規の場合 */
      if (editId === -1) {
        this.costTypeA = true;
        this.costTypeB = false;
        url += "-1/edit";
      } else {
        url += this.$route.params.id + "/edit";
      }
      const params: object = this.setAxiosParams(url, accessMethod);

      axios(params)
        .then((response: any): void => {
          this.editData = response.data;
          if (editId === -1) {
            this.defData.id = -1;
            this.editData.coater = this.defData;
            Object.keys(this.editData.itemPaperSizes).forEach(
              (k: string): void => {
                this.paperSizeList.push(k);
                this.machinePaperSizeList.push(k);
              }
            );
          } else {
            /** 用紙セレクタの追加 */
            if (this.editData.coater.costType === "machine") {
              this.costTypeA = false;
              this.costTypeB = true;
              Object.keys(
                this.editData.coater.machineCoatingCostPerSheets
              ).some((k: string): boolean => {
                this.selectedMachinePaper = k;
                return true;
              });
              Object.keys(this.editData.itemPaperSizes).forEach(
                (k: string): void => {
                  this.paperSizeList.push(k);
                  const hasKey: boolean = Object.keys(
                    this.editData.coater.machineCoatingCostPerSheets
                  ).some((key: string): boolean => {
                    if (key === k) {
                      return true;
                    } else {
                      return false;
                    }
                  });
                  if (hasKey === false) {
                    this.machinePaperSizeList.push(k);
                  }
                }
              );
            } else {
              this.costTypeA = true;
              this.costTypeB = false;
              Object.keys(this.editData.coater.manualCoatingCosts).some(
                (k: string): boolean => {
                  this.selectedPaper = k;
                  return true;
                }
              );
              Object.keys(this.editData.itemPaperSizes).forEach(
                (k: string): void => {
                  this.machinePaperSizeList.push(k);
                  const hasKey: boolean = Object.keys(
                    this.editData.coater.manualCoatingCosts
                  ).some((key: string): boolean => {
                    if (key === k) {
                      return true;
                    } else {
                      return false;
                    }
                  });
                  if (hasKey === false) {
                    this.paperSizeList.push(k);
                  }
                }
              );
            }
          }
          Object.keys(this.editData.coatingTypes).forEach((k: string): void => {
            this.defData.manualCoatingFixedCosts.push({
              coatingTypeId: k,
              cost: 0
            });
          });
        })
        .catch((error: any): void => {
          console.log("[mount error]", error.response);
          this.toLoginPage(error);
        });
    }
  }

  checkInputKeys(e: KeyboardEvent): void {
    if (e.ctrlKey === true && e.key === "Enter") {
      this.onSubmit();
    }
  }

  showPaperSizeSelector(show: boolean): void {
    this.paperSizeShows = show;
    if (show === true) {
      /** paperSizeSelector 最上段選択しておく */
      this.$nextTick((): void => {
        const selector: HTMLSelectElement = document.getElementById(
          "paperSizeSelector"
        ) as HTMLSelectElement;
        selector.selectedIndex = 0;
      });
    }
  }

  selectPaper(paperName: string): void {
    if (paperName === this.selectedPaper) {
      return;
    }
    this.selectedPaper = paperName;
    this.checkManualCosts();
  }

  selectMachinePaper(paperName: string): void {
    if (paperName === this.selectedMachinePaper) {
      return;
    }
    this.selectedMachinePaper = paperName;
    this.resetSheetFromEle();
    this.$nextTick((): void => {
      this.setSheetFrom();
      const sheetValueCheck: any = this.checkSheetValue(
        this.editData.coater.machineCoatingCostPerSheets
      );

      this.checkMachineCosts();
      /** sheetFromおかしかったらエラー出す */
      this.errantSheet = [];
      Object.keys(sheetValueCheck).forEach((k: string): void => {
        if (sheetValueCheck[k][1] !== -1) {
          if (k === this.selectedMachinePaper) {
            this.showSheetFromError(
              sheetValueCheck[this.selectedMachinePaper],
              "sheetFrom",
              false
            );
          }
          this.errantSheet.push(k);
        }
      });
    });
  }

  checkSheetError(key: string): boolean {
    let isError = false;
    for (const item of this.errantSheet) {
      if (item === key) {
        isError = true;
        break;
      }
    }

    for (const item of this.errantCost) {
      if (item === key) {
        isError = true;
        break;
      }
    }
    return isError;
  }

  onSubmit(back = false): void {
    const mes = this.$t("message.editCommon.saveConfirmation");
    const confirmation: boolean = confirm(mes as string);
    if (confirmation === false) {
      return;
    }
    const editData: any = this.editData;
    const bool: boolean = this.resetSheetFromEle();
    if (bool === true) {
      return;
    }

    if (editData.coater.costType === "machine") {
      this.setSheetFrom();
      const sheetValueCheck: any = this.checkSheetValue(
        editData.coater.machineCoatingCostPerSheets
      );
      this.checkMachineCosts();

      /** sheetFromおかしかったらエラー出す */
      this.errantSheet = [];
      Object.keys(sheetValueCheck).forEach((k: string): void => {
        if (sheetValueCheck[k][1] !== -1) {
          if (k === this.selectedMachinePaper) {
            this.showSheetFromError(sheetValueCheck[this.selectedMachinePaper]);
          }
          this.errantSheet.push(k);
        }
      });

      if (this.errantSheet.length > 0 || this.errantCost.length > 0) {
        return;
      }

      /** itemCoaterId統一(新規継続対策) */
      const mccps: any = editData.coater.machineCoatingCostPerSheets;
      Object.keys(mccps).forEach((k: string): void => {
        for (const item of mccps[k]) {
          item.itemCoaterId = editData.coater.id;
        }
      });

      /** 問題なかったらsheetToの値を設定 */
      this.setSheetTo();
      editData.coater.manualCoatingFixedCosts = [];
      editData.coater.manualCoatingCosts = [];
    } else {
      this.checkManualCosts();
      editData.coater.machineCoatingMinimumCosts = [];
      editData.coater.machineCoatingCostPerSheets = [];
    }

    /** 表記の揺れ対策 */
    interface CategoryObj {
      category: string;
      backTo: string;
      dataName: string;
    }
    const categoryObj: CategoryObj = {
      category: "coater",
      backTo: "Coater",
      dataName: "coater"
    };
    const id: number = parseInt(editData.coater.id, 10);
    this.sendEditData(id, editData, categoryObj, back, this.afterSaving);
  }

  afterSaving(): void {
    /** セーブ後errantSheet初期化 */
    this.errantSheet.length = 0;
    this.errantCost.length = 0;
    this.resetSheetFromEle();
  }

  /** コストタイプ変更 */
  changeCostType(costType: string): void {
    const data: any = this.editData.coater;
    data.costType = costType;

    /** 初期値を設定する  */
    if (costType === "machine") {
      /** Manualで保存されていたデータの場合、Array型で配信される対策 */
      if (
        data.machineCoatingCostPerSheets === null ||
        this.getName(data.machineCoatingCostPerSheets) === "Array"
      ) {
        data.machineCoatingCostPerSheets = {};
      }
      if (
        data.machineCoatingMinimumCosts === null ||
        this.getName(data.machineCoatingMinimumCosts) === "Array"
      ) {
        data.machineCoatingMinimumCosts = {};
      }
    } else {
      if (data.manualCoatingFixedCosts.length === 0) {
        data.manualCoatingFixedCosts = Object.assign(
          [],
          this.defData.manualCoatingFixedCosts
        );
      }
      if (
        data.manualCoatingCosts === null ||
        this.getName(data.manualCoatingCosts) === "Array"
      ) {
        data.manualCoatingCosts = {};
      }
    }
  }

  addCell(arr: any[]): void {
    const len: number = arr.length - 1;
    interface NewItem {
      itemCoaterId: number;
      itemPaperSizeId: number;
      coatingTypeId: number;
      sheetFrom: number;
      sheetTo: number;
      cost: number;
    }
    const newItems: NewItem[] = [];
    let i = 0;

    for (const item of arr[len]) {
      newItems[i] = {
        itemCoaterId: item.itemGlueId,
        itemPaperSizeId: item.boxTypeId,
        coatingTypeId: item.coatingTypeId,
        sheetFrom: item.sheetFrom,
        sheetTo: item.sheetTo,
        cost: parseFloat(item.cost)
      };
      i += 1 | 0;
    }
    let sheetFrom: any = newItems[0].sheetFrom;
    sheetFrom = parseInt(sheetFrom, 10);
    const newSheetFrom: number = sheetFrom + 1;
    let item: NewItem;
    for (item of newItems) {
      item.sheetFrom = newSheetFrom;
    }
    arr.push(newItems);
    this.$forceUpdate();
  }

  /** sheetFromをすべての配列に設定 */
  setSheetFrom(): void {
    const sheet: any = this.editData.coater.machineCoatingCostPerSheets;
    Object.keys(sheet).forEach((k: string): void => {
      for (const item of sheet[k]) {
        const sheetFrom: number =
          item[0].sheetFrom === undefined ? 1 : parseInt(item[0].sheetFrom, 10);
        for (const cost of item) {
          cost.sheetFrom = sheetFrom;
          cost.cost = parseFloat(cost.cost);
        }
      }
    });
  }

  /** sheetToの値を設定する */
  setSheetTo(): void {
    const mccps: any = this.editData.coater.machineCoatingCostPerSheets;
    let i: number;
    let j: number;
    const coaterId: number = this.editData.coater.id;
    Object.keys(mccps).forEach((k: string): void => {
      for (i = 0; i < mccps[k].length; i++) {
        j = i + 1;
        for (const item of mccps[k][i]) {
          /** itemGlueId(新規継続対策) */
          item.itemGlueId = coaterId;
          item.sheetTo = mccps[k][j] ? mccps[k][j][0].sheetFrom - 1 : -1;
        }
      }
    });
  }

  checkManualCosts(): void {
    this.errantCost = [];
    const costs: any = this.editData.coater.manualCoatingCosts;
    Object.keys(costs).forEach((k: string): void => {
      for (const item of costs[k]) {
        if (Number.isNaN(item.cost) === true || item.cost === "") {
          this.errantCost.push(k);
          break;
        }
      }
    });
  }

  checkMachineCosts(): void {
    this.errantCost = [];
    const costs: any = this.editData.coater.machineCoatingCostPerSheets;
    Object.keys(costs).forEach((k: string): void => {
      costBlock: for (const arr of costs[k]) {
        for (const item of arr) {
          if (
            item.sheetFrom === undefined ||
            Number.isNaN(item.sheetFrom) === true ||
            Number.isNaN(item.sheetTo) === true ||
            Number.isNaN(item.cost) === true ||
            item.sheetFrom === "" ||
            item.cost === ""
          ) {
            this.errantCost.push(k);
            break costBlock;
          }
        }
      }
    });
  }

  checkSheetValue(obj: any): any {
    const checkedSheets: any = {};
    Object.keys(obj).forEach((k: string): void => {
      let sheetFrom: number = parseInt(obj[k][0][0].sheetFrom, 10) as number;
      let prevFrom: number;
      let erroredNumber = -1;
      let i = 1;
      for (i = 1; i < obj[k].length; i++) {
        prevFrom = parseInt(obj[k][i][0].sheetFrom, 10);
        if (prevFrom <= sheetFrom) {
          erroredNumber = sheetFrom;
          break;
        } else {
          sheetFrom = prevFrom;
        }
      }
      checkedSheets[k] = [i, erroredNumber];
    });
    return checkedSheets;
  }
}
